import { createServerFn } from '@tanstack/react-start';
import { getRequestHeaders, setResponseHeader } from '@tanstack/react-start/server';

import { getBlogPreview, type BlogPreviewData } from '#features/blog/model/blog';
import { readPreviewToken } from '#features/blog/server/previewHandoff';

/**
 * Exchanges the preview cookie for the draft. Runs on the server only: the cookie is httpOnly
 * and path-scoped, so the browser never sees the token and the page never re-fetches it on the
 * client. A missing or refused token gives null, and the page says the link has expired.
 * The response is no-store: a draft must not survive in any cache, shared or private.
 */
export const loadBlogPreview = createServerFn({ method: 'GET' }).handler(
  async (): Promise<BlogPreviewData | null> => {
    setResponseHeader('Cache-Control', 'no-store');
    setResponseHeader('Referrer-Policy', 'no-referrer');

    const token = readPreviewToken(getRequestHeaders().get('cookie'));
    if (!token) {
      return null;
    }

    return getBlogPreview(token);
  }
);
